import Environment from '@di-shared/features/environment/Environment';
import LottieSelector, {LottieSelectorWrapperProps} from '@di-shared/features/common/LottieSelector';
import React, {useEffect, useRef} from 'react';
import {LottieRefCurrentProps} from 'lottie-react';
import useIntersectionObserver from '@shared/useHandleObserver';
import Eu from '@di-shared/features/about/About/.eu';
import Kr from '@di-shared/features/about/About/.kr';

export default function About() {
  return (
    <>
      <Environment.Eu>
        <Eu />
      </Environment.Eu>
      <Environment.Kr>
        <Kr />
      </Environment.Kr>
    </>
  );
}

export function InteractionLottie(props: LottieSelectorWrapperProps) {
  const lottieRef = useRef<LottieRefCurrentProps>(null);
  const {observerRef} = useIntersectionObserver(handleObserver, {threshold: 0.8});

  function handleObserver(entry: IntersectionObserverEntry) {
    if (entry.isIntersecting) {
      lottieRef.current?.stop();
      lottieRef.current?.play();
    }
  }

  useEffect(() => {
    setTimeout(() => {
      // 최초 1번은 로띠가 재생되고 있게끔 (화면이 복원되는 케이스 등에서 옵저버가 반응하기 전 대응)
      lottieRef.current?.play();
    }, 100);
  }, []);

  return (
    <div
      ref={observerRef}
      className="intro_imgbox"
      aria-hidden="true"
    >
      <LottieSelector
        lottieRef={lottieRef}
        {...props}
      />
    </div>
  );
}
